/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const userInputFieldSchema = z.object({
  id: z.string(),
  label: z.string(),
  required: z.boolean(),
});
